import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetResultsVerificationAssignees } from 'services/results/hooks/useGetResultsVerificationAssignees'

interface AssigneeFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const AssigneeFilter = ({ onApply, onReset }: AssigneeFilterProps) => {
  const assigneesQuery = useGetResultsVerificationAssignees()

  const assigneeOptions =
    assigneesQuery.data?.data.map(item => ({
      label: item.email,
      value: item._id
    })) ?? []

  const options = [{ label: 'Unassigned', value: 'unassigned' }, ...assigneeOptions]

  return (
    <CheckboxFilter
      label="Assignee"
      loading={assigneesQuery.isLoading}
      onApply={onApply}
      onReset={onReset}
      options={options}
      searchFieldPlaceholder="Search by email"
    />
  )
}
